import animatedScrollTo, { IUserOptions } from 'animated-scroll-to';

export async function scrollTo(
  dom: HTMLElement,
  options: IUserOptions = {
    speed: 500,
  },
) {
  animatedScrollTo(dom, options);
}
